export default __webpack_public_path__ + "static/media/learn_illus_basic.3e91f06c.png";